<div class="delete-collection-popup">
  <div class="delete-collection-header">
    <label class="collection-header-title">Remove Collection From Node</label>
    <button class="header-close" (click)="closePopup()"></button>
  </div>
  @if (collection?.name.length > 20 ) {
    <div class="delete-collection-content">
      Do you want to remove collection <span matTooltip="{{collection?.name}}" matTooltipPosition="above">"{{collection?.name.length > 20 ? collection?.name.substring(0, 17) + '...' : collection?.name}}"</span> from {{ collection?.stepTitle | upperCaseFirstLetter }}?
    </div>
  }
  @if (collection?.name.length <= 20 ) {
    <div class="delete-collection-content">
      Do you want to remove collection "{{collection?.name}}" from {{ collection?.stepTitle | upperCaseFirstLetter }}?
    </div>
  }
  <div class="delete-collection-footer">
    <button class="collection-delete" mat-button (click)="deleteCollection()">Remove Collection</button>
    <button mat-button mat-dialog-close class="collection-popup-close" (click)="closePopup()">Cancel</button>
  </div>

</div>